// Where the live game stands inside the current stage, for the cyclist
// progress bar (components/StageProgress.vue): the ordered activities of the
// stage the current question belongs to, and the position of the current one.
//
// Same order the server plays them in: an active stage playback carries its
// own authoritative question_ids; otherwise the stage's questions sorted by
// the admin's drag order (question.order, see reorder_activities in
// server.js), stable so legacy rows without it keep creation order.
// Returns null when there's no current question to place.
export function stageProgress(game) {
    const current = game?.question;
    const current_id = current?.question?.id ?? current?.id ?? game?.current_question;
    if (current_id == null) return null;

    const questions = (game.questions || []).filter((q) => q && q.question);
    const playback = game.stage_playback;
    let ordered;

    if (playback && Array.isArray(playback.question_ids) && playback.question_ids.includes(current_id)) {
        ordered = playback.question_ids.map((id) => questions.find((q) => q.id == id)).filter(Boolean);
    } else {
        const stage_id = current?.question?.stage_id
            ?? questions.find((q) => q.id == current_id)?.question.stage_id;
        ordered = questions
            .filter((q) => q.question.stage_id == stage_id)
            .map((q, i) => ({ q, i }))
            .sort((a, b) => ((a.q.question.order || 0) - (b.q.question.order || 0)) || (a.i - b.i))
            .map(({ q }) => q);
    }

    const index = ordered.findIndex((q) => q.id == current_id);
    if (index < 0) return null;

    return { types: ordered.map((q) => q.question.type), index };
}
